/* RESPONSIBLE TEAM: team-inbox-management */
import type Session from 'embercom/services/session';

export function canExportConversationTranscriptsInbox2(session: Session) {
  return session.teammate.permissions.canInboxConversationTranscriptsExport;
}

export function canExportConversationTranscriptsInbox1(appService: any) {
  return appService.app.currentAdmin.currentAppPermissions
    .can_inbox__conversation_transcripts__export;
}

export let exportConversationTranscriptsPermission = 'can_inbox__conversation_transcripts__export';
